

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { loginUser } from "../config/config";

const Login = ({setEmail}) => {
  const [email, setEmailState] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);

    const result = await loginUser(email, password, rememberMe);

    if (result.success) {
      console.log(email);
      navigate("/transaction");

    } else {
      setError(result.message);
    }
  };

  return (

    <div className="d-flex  justify-content-center vh-100 " >
      <div className="p-4 mt-5" style={{ maxWidth: "350px", width: "100%" }}>
        <h3 className="text-start mb-4">Sign In</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmailState(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="rememberMe"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label htmlFor="rememberMe" className="form-check-label">
              Remember Me
            </label>
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Sign In
          </button>
          {error && <div className="text-danger text-center mt-3">{error}</div>}
        </form>
      </div>
    </div>
  );
};

export default Login;
